import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSunsetFilled = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 16 16",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M8.5 1.833a.5.5 0 1 0-1 0v.687a.5.5 0 0 0 1 0zM3.994 3.29a.5.5 0 1 0-.708.706l.485.485a.5.5 0 0 0 .707-.707zm8.72.706a.5.5 0 0 0-.708-.707l-.484.485a.5.5 0 1 0 .707.707zM1.833 7.667a.5.5 0 0 0 0 1h.686a.5.5 0 0 0 0-1zm11.649 0a.5.5 0 0 0 0 1h.685a.5.5 0 0 0 0-1zM1.833 10.333a.5.5 0 0 0 0 1h12.334a.5.5 0 1 0 0-1zM4.5 13a.5.5 0 0 0 0 1h7a.5.5 0 1 0 0-1zm6.333-4.333a.5.5 0 0 0 .5-.5v-.162A3.336 3.336 0 0 0 8 4.667a3.336 3.336 0 0 0-3.333 3.338v.162a.5.5 0 0 0 .5.5z"
	})
});
export default SvgSunsetFilled;
